import React, { useEffect, useState } from "react";
import "./personalInfo.css";
import Icons from "../../Assets/Icons";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import useValidation from "../../utils/validators";
import DatePicker from "react-multi-date-picker";
import Widgets from "../../widgets";
import { format } from "date-fns";
import { verifyPersonalInfo } from "../../modules/patientProfile/patientProfileThunk";
import { resetVerifyPrsnlInfo, resetRejectHnReq } from "../../modules/patientProfile/patientProfileSlice";
import { setStatus } from "../../modules/status/status";
import ToastPopup from "../../widgets/Toast/toastPopup";
import moment from "moment";

const PersonalInfo = ({ userId, setPage, userProfile, setRequestData, setSelectedView, hasHn, status }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { validateStep1 } = useValidation();
  const { verifyPrsnlInfoError, verifyPrsnlInfo, rejectHnReqErr, rejectHnReq } = useSelector((state) => state.patientProfile);
  const [showReject, setShowReject] = useState(false);

  useEffect(() => {
    if (rejectHnReqErr) {
      ToastPopup.error(rejectHnReqErr);
    }
    if (rejectHnReq && rejectHnReq.data.rejected) {
      ToastPopup.success(t("reqRejected"));
      setSelectedView("patientProfileList");
    }
    dispatch(resetRejectHnReq());
  }, [rejectHnReqErr, rejectHnReq]);

  useEffect(() => {
    if (verifyPrsnlInfoError) {
      ToastPopup.error(verifyPrsnlInfoError);
    }
    if (verifyPrsnlInfo && verifyPrsnlInfo.status === "success") {
      dispatch(setStatus("IN_REVIEW"));
      ToastPopup.success(t("reqAssigToYou"));
      setPage(2);
    }
    dispatch(resetVerifyPrsnlInfo());
  }, [verifyPrsnlInfoError, verifyPrsnlInfo]);

  const formatDate = (date) => {
    console.log(date);
    let dateObj;

    if (typeof date === "object") {
      dateObj = new Date(date);
    } else if (typeof date === "string") {
      const [day, month, year] = date.split("/");
      dateObj = new Date(`${year}-${month}-${day}`);
    } else {
      throw new Error("Unsupported date format");
    }
    return dateObj.toISOString().slice(0, 10);
  };

  const handleVerify = (userId) => {
    const updatedInfo = {
      firstAndMiddleName: userProfile.firstName,
      lastName: userProfile.lastName,
      dateOfBirth: formatDate(userProfile.dateOfBirth),
      gender: userProfile.gender,
    };
    validateStep1(updatedInfo);
    dispatch(verifyPersonalInfo({ userId, updatedInfo }));
  };
  const setNextPage = () => {
    const updatedInfo = {
      firstAndMiddleName: userProfile.firstName,
      lastName: userProfile.lastName,
      dateOfBirth: formatDate(userProfile.dateOfBirth),
      gender: userProfile.gender,
    };
    const isValid = validateStep1(updatedInfo);
    if (isValid) {
      setPage(2);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRequestData((prevProfile) => ({
      ...prevProfile,
      relative: {
        ...prevProfile.relative,
        [name]: value.trimStart(),
      },
    }));
  };

  const getFormattedDate = (date) => {
    let dateObj;
    if (typeof date === "object") {
      dateObj = new Date(date);
    } else if (typeof date === "string" && date.includes("T")) {
      dateObj = new Date(date);
    } else if (typeof date === "string") {
      dateObj = moment(date, "DD/MM/YYYY").toDate();
    } else {
      throw new Error("Unsupported date format");
    }
    return format(dateObj, "dd MMM, yyyy");
  };

  const weekDays = ["S", "M", "T", "W", "T", "F", "S"];

  const getDateYearsBefore = (years) => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - years);
    return date;
  };

  const genderMapping = {
    [`${t("male")}`]: "Male",
    [`${t("female")}`]: "Female",
  };
  const oppGenderMapping = {
    ["Male"]: t("male"),
    ["Female"]: t("female"),
  };

  const handleReject = () => {
    setShowReject(true);
  };

  const handleCancelReject = () => {
    setShowReject(false);
  };

  const handleConfirmReject = () => {
    setShowReject(false);
  };

  const convertToISODate = (date) => {
    let dateObj;
    if (typeof date === "object") {
      dateObj = new Date(date);
    } else if (typeof date === "string" && date.includes("/")) {
      const [day, month, year] = date.split("/");
      dateObj = new Date(`${year}-${month}-${day}`);
    } else {
      dateObj = new Date(date);
    }
    return dateObj.toISOString();
  };

  return (
    <div className="verification-request">
      {userProfile && (
        <div className="pdl-info verify">
          <p className="pdl-title">{t("personalInformation")}</p>
          <div className="pdl-body">
            <div className="pdl-section-left">
              {userProfile.profilePhoto ? <img src={userProfile.profilePhoto} alt="profile" /> : <img src={Icons.noProfile} alt="profile" />}
              <p className="pdl-name prsnl-info">
                <input
                  type="text"
                  value={userProfile.firstName}
                  className="first-name-info"
                  name="firstName"
                  onChange={handleChange}
                  placeholder={t("placeholderFirstName")}
                  style={{ width: `${Math.max(userProfile.firstName.length, 1)}ch` }}
                />
                <input
                  type="text"
                  className="last-name-info"
                  onChange={handleChange}
                  name="lastName"
                  value={userProfile.lastName}
                  placeholder={t("placeholderLastName")}
                  style={{ width: `${Math.max(userProfile.lastName.length, 1)}ch` }}
                />
              </p>
              <p className="pdl-gender">
                <Widgets.SelectDropdown
                  options={[`${t("male")}`, `${t("female")}`]}
                  selectedValue={oppGenderMapping[userProfile.gender]}
                  onChange={(selectedValue) => {
                    const englishGender = genderMapping[selectedValue];
                    setRequestData((prevState) => ({
                      ...prevState,
                      relative: {
                        ...prevState.relative,
                        gender: selectedValue,
                        genderToShow: englishGender,
                      },
                    }));
                  }}
                  placeholder="selectGender"
                  big
                />
              </p>
            </div>
            <div className="pdl-section-right">
              <section className="pdl-phone-dob">
                <div className="pdl-detail">
                  <img src={Icons.Call} alt="call" />
                  <span>
                    +{userProfile.countryCode} {userProfile.phoneNumber}
                  </span>
                </div>
                <div className="pdl-detail date-pick">
                  <img src={Icons.CalenderIcon} alt="calender" />
                  <span>{getFormattedDate(userProfile.dateOfBirth)}</span>
                  <div className="custom-date-picker">
                    <DatePicker
                      value={convertToISODate(userProfile.dateOfBirth)}
                      onChange={(date) =>
                        setRequestData((prevState) => ({
                          ...prevState,
                          relative: {
                            ...prevState.relative,
                            dateOfBirth: date,
                          },
                        }))
                      }
                      format="MM/DD/YYYY"
                      editable={false}
                      weekDays={weekDays}
                      minDate={getDateYearsBefore(110)}
                      maxDate={getDateYearsBefore(0)}
                    />
                  </div>
                </div>
              </section>
              <section></section>
              {userProfile.email && (
                <section className="pdl-detail">
                  <img src={Icons.SmsIcon} alt="mail" />
                  <span>{userProfile.email}</span>
                </section>
              )}
              {userProfile.hnNumber ? (
                <section className="pdl-hn">
                  <p className="pdl-hn-title">
                    {t("hnNumber")}
                    <span className="asterik">*</span>
                  </p>
                  <p className="pdl-number">{userProfile.hnNumber && userProfile.hnNumber}</p>
                </section>
              ) : null}
            </div>
          </div>
          <div className="save-speciality info">
            {status === "OPEN" ? (
              <>
                <div className="speciality-cancel reject" onClick={handleReject}>
                  {t("reject")}
                </div>
                <div className="speciality-save" onClick={() => handleVerify(userId)}>
                  {t("assignYou")}
                </div>
              </>
            ) : (
              <>
                <div className="speciality-cancel reject" onClick={handleReject}>
                  {t("reject")}
                </div>
                <div className="speciality-save" onClick={() => setNextPage(2)}>
                  {t("next")}
                </div>
              </>
            )}
          </div>
        </div>
      )}
      <Widgets.Reject showModal={showReject} handleCancel={handleCancelReject} handleConfirm={handleConfirmReject} reason="rejectPatientDetails" userId={userId} />
    </div>
  );
};

export default PersonalInfo;
